export enum AuroraControlId {
  ZoneSource = 'ZoneSource',
  ZoneBreaks = 'ZoneBreaks',
  ZoneRates = 'ZoneRates',
  SavePrescription = 'SavePrescription'
}

export const AURORA_CONTROL_DESCRIPTIONS: Record<AuroraControlId, string> = {
  [AuroraControlId.ZoneSource]:
    'the layer the zones come from: an as-applied pass layer by season, a soil sample analyte, or a soil survey attribute. Required before any zones exist.',
  [AuroraControlId.ZoneBreaks]:
    "a slider over the layer's histogram for dragging the values where one zone ends and the next begins, listing each zone's range and acres.",
  [AuroraControlId.ZoneRates]:
    "the rate grid: a rate for each zone, with each zone's acres and the prescription's totals and averages.",
  [AuroraControlId.SavePrescription]:
    'the button that saves the prescription. Only the user can press it; when they do, a message says which products were saved and why any were not. Saved products leave the form, so the products still in it are the ones left to save.'
}
